import React, { useEffect, useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useUserAuth } from "../../contexts/authContext";

export default function DfrNotes(props) {
    const [flight] = useState(props.flight);
    const [incident, setIncident] = useState("");
    const [location, setLocation] = useState("");
    const [summary, setSummary] = useState("");

    const { handleFailedFetch } = useUserAuth();

    useEffect(() => {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" }
        };
        fetch(`/api/dfr/get/${flight.flight_uuid}`, requestOptions)
            .then((response) => (response.ok ? response.json() : Promise.reject(response)))
            .then((data) => preloadData(data))
            .catch((err) => handleFailedFetch(err));
    }, []);

    const preloadData = (dfr) => {
        if (!dfr) {
            return;
        }

        setIncident(dfr.incident);
        setLocation(dfr.location);
        setSummary(dfr.summary);
    };

    const handleSubmit = () => {
        const dfr = {
            flight_uuid: flight.flight_uuid,
            published: false,
            incident,
            location,
            summary
        };
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(dfr)
        };
        fetch("/api/dfr/insertUpdate", requestOptions)
            .then((response) => (response.ok ? response.json() : Promise.reject(response)))
            .then(() => handleClose())
            .catch((err) => handleFailedFetch(err));
    };

    const handleClose = () => {
        props.setNotesOpen(false);
    };

    return (
        <Dialog open={true} onClose={handleClose} maxWidth="lg" PaperProps={{ sx: { minWidth: { sm: "500px" }, width: { xs: "100%", sm: "auto" } } }}>
            <DialogTitle sx={{ pb: 0 }}>Flight Notes</DialogTitle>
            <DialogContent sx={{ width: "100%", pb: 0 }}>
                <Box sx={{ height: "100%", display: "flex", flexDirection: "column", gap: "12px", "& > *": { margin: "0 !important" }, pt: "20px" }}>
                    <TextField label="Flight" value={flight.name} fullWidth disabled />
                    <TextField label="Case/Incident" value={incident} onChange={(e) => setIncident(e.target.value)} fullWidth />
                    <TextField label="Location" value={location} onChange={(e) => setLocation(e.target.value)} fullWidth />
                    <TextField label="Summary" value={summary} onChange={(e) => setSummary(e.target.value)} fullWidth multiline />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} sx={{ mr: "auto" }}>
                    Close
                </Button>
                <Button onClick={handleSubmit}>Save</Button>
            </DialogActions>
        </Dialog>
    );
}
